import { SuretyAccountId } from "@inrev/common";
import { getDefaultTab, Tab, TabBar } from "@portal/components/ui/TabBar";
import { FC, useCallback, useState } from "react";
import { NonEmptyArray } from "../../../../../shared/types";
import { AdminAccountBondsTable } from "../../AdminAccountBondsTable";
import { AdminAccountBondRequestsTable } from "./AdminAccountBondRequestsTable";

type BondSectionTab = { accountId: SuretyAccountId };

const BidBondsTab = ({ accountId }: BondSectionTab) => (
	<AdminAccountBondsTable accountId={accountId} filterType="bid" status="open" />
);

const FinalBondsTab = ({ accountId }: BondSectionTab) => (
	<AdminAccountBondsTable accountId={accountId} filterType="final" status="open" />
);

const BOND_SECTION_TABS: NonEmptyArray<Tab<BondSectionTab>> = [
	{
		id: "requests",
		label: "Requests",
		Component: AdminAccountBondRequestsTable,
		isDefault: true,
	},
	{ id: "bid-bonds", label: "Bid Bonds", Component: BidBondsTab },
	{ id: "final-bonds", label: "Final Bonds", Component: FinalBondsTab },
];

type AdminAccountBondsAndRequestsProps = { accountId: SuretyAccountId };
export const AdminAccountBondsAndRequests: FC<AdminAccountBondsAndRequestsProps> = ({
	accountId,
}) => {
	const [activeBondSectionTab, setActiveBondSectionTab] = useState(
		getDefaultTab(BOND_SECTION_TABS),
	);

	const handleTabChange = useCallback((id: string) => {
		const tab = BOND_SECTION_TABS.find((t) => t.id === id);
		if (tab) setActiveBondSectionTab(tab);
	}, []);

	const Component = activeBondSectionTab.Component;

	return (
		<div className="flex flex-col w-full space-y-2">
			<div className="flex items-center justify-between">
				<TabBar
					options={BOND_SECTION_TABS}
					activeTabId={activeBondSectionTab.id}
					onTabChange={handleTabChange}
				/>
			</div>
			<Component accountId={accountId} />
		</div>
	);
};
